import { formatDate, getDateFromArray } from '../../utils/dateUtil';

export const createHolidayObjectByCurrency = (data: any[]) => {
  const holidayObject = data.reduce((holidays, currHoliday) => {
    if (!holidays[currHoliday.countryShortCode]) {
      holidays[currHoliday.countryShortCode] = [];
    }
    holidays[currHoliday.countryShortCode].push({
      id: currHoliday.id,
      calendarType: currHoliday.calendarType,
      country: currHoliday.country,
      countryShortCode: currHoliday.countryShortCode,
      holidayDate: formatDate(getDateFromArray(currHoliday.holidayDate)),
      holidayName: currHoliday.holidayName,
      year: currHoliday.year,
    });
    return holidays;
  }, {});
  return holidayObject;
};
